import { render, staticRenderFns } from "./friendBindUserList.vue?vue&type=template&id=216992f1&scoped=true"
import script from "./friendBindUserList.vue?vue&type=script&lang=js"
export * from "./friendBindUserList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216992f1",
  null
  
)

export default component.exports